import { render, staticRenderFns } from "./PostStatusDistribution.vue?vue&type=template&id=32c36b7b&scoped=true"
import script from "./PostStatusDistribution.vue?vue&type=script&lang=js"
export * from "./PostStatusDistribution.vue?vue&type=script&lang=js"
import style0 from "./PostStatusDistribution.vue?vue&type=style&index=0&id=32c36b7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c36b7b",
  null
  
)

export default component.exports